import React from 'react';
import Svg, { ISvgProps } from './_module/Svg';

interface IProps extends Omit<ISvgProps, 'svgIcon'> {}

export default function KeepitalAccountAppSvg(props: IProps) {
  const { width, height } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      svgIcon='<circle class="circle_outer brand-gray" cx="15.6" cy="16.2" r="12.7"/><circle class="circle_inner white"  cx="15.6" cy="16.2" r="11.6"/><path class="user brand-primary" d="M13.3,21c-1.1,0.2-4.3,1.5-6,3.3c2.1,2.2,5.1,3.6,8.4,3.6s6.3-1.4,8.4-3.6 c-1.7-1.8-4.9-3.1-6-3.3h0c-0.5-0.1-0.5-1.4-0.5-1.4s1.4-1.4,1.7-3.2c0.8,0,1.3-1.9,0.5-2.6c0-0.7,1-5.6-4-5.6c-5.1,0-4.1,4.9-4,5.6 c-0.8,0.7-0.3,2.6,0.5,2.6c0.3,1.8,1.7,3.2,1.7,3.2S13.8,20.9,13.3,21z"/>'
    />
  );
}
